/**
 * Template Selection Progress Component
 * Displays the status of template selection step
 */

import { TemplateSelectionStatus } from '@/types/workflow';
import { CheckCircle2 } from 'lucide-react';

interface TemplateSelectionProgressProps {
  templateStatus: TemplateSelectionStatus;
}

export function TemplateSelectionProgress({ templateStatus }: TemplateSelectionProgressProps) {
  if (templateStatus.status === 'completed' && templateStatus.selectedTemplate) {
    return (
      <div className="flex items-center gap-2 text-xs text-gray-700">
        <CheckCircle2 className="h-3.5 w-3.5 text-green-600 flex-shrink-0" />
        <span>
          <span className="text-gray-600">Template:</span>{' '}
          <span className="font-medium">{templateStatus.selectedTemplateName || templateStatus.selectedTemplate}</span>
        </span>
      </div>
    );
  }

  return null; // Don't show anything when pending - action button is enough
}
